import { Category, CategoryEntity } from "./Category";
import { Answer, Question } from "./Question";

export interface GameData {
  isLoading: boolean;
  categories: Array<Category>;
  firstTeamName: string;
  secondTeamName: string;
  currentTeamTurn: TeamTurns;
  firstTeamScore: number;
  secondTeamScore: number;
  isUnfinished?: boolean;
  resultGame?: Game;
}

export interface UpdateGameRequestModel {
  id: string
  isCompleted?: boolean
}

export interface Game {
  _id?: string;
  createdAt?: Date;
}

export interface GiveRatingRequestModel {
  feedback?: string;
  rate: number;
}


export enum TeamTurns {
  teamA = "teamA",
  teamB = "teamB",
}
